const ERROR_STATUS = 400;

async function fetchApI(endpoint: string) {
  const response = await fetch(endpoint, {
    method: 'GET',
    credentials: 'same-origin',
  });

  if (response.status >= ERROR_STATUS) {
    throw new Error(String(response.status));
  }

  const responseText = await response.text();

  return responseText.length ? JSON.parse(responseText) : {};
}

export default fetchApI;
